import { DocumentServicesObject } from '@wix/document-services-types';
import { EditorEventHandlers } from './handlers';
import { handleTPAMessage } from './common/SdkPostMessageCommon';
import { SdkEvent, TPAMessage } from './types/tpaMessage';
import { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';

interface SdkEventHandlerServiceMethods {
  initializeListenerHandlers: () => void;
}

export const SdkEventHandlerService = (
  listenerMethod: Window['addEventListener'],
  handlers: EditorEventHandlers,
  documentServicesAPI: DocumentServicesObject,
  platformApiMethods: PlatformApiMethods,
): SdkEventHandlerServiceMethods => {
  const getEventHandler = (msg: TPAMessage) => {
    // TODO check if we need to support specific case with santa's editorSettingsModalHandlers -> resizeWindow
    return handlers[msg.type];
  };

  const setSelectedComponentIdToMessage = async (msg: TPAMessage) => {
    const [selectedComponent] =
      await platformApiMethods.editor.selection.getSelectedComponents();

    if (selectedComponent) {
      msg.compId = selectedComponent.id;
    }
  };

  const callHandler = async (msg: TPAMessage, response: any) => {
    const handler = getEventHandler(msg);
    await setSelectedComponentIdToMessage(msg);

    if (handler) {
      handler.call(null, msg, response);
      // @ts-expect-error
      documentServicesAPI.tpa.bi.sendBIEvent(msg, 'editor');
    } else {
      // @ts-expect-error
      documentServicesAPI.tpa.handlers(
        {
          ...msg,
          originFrame: 'editor',
        },
        response,
      );
    }
  };

  const initializeListenerHandlers = () => {
    listenerMethod(
      'message',
      (event: MessageEvent<SdkEvent>) =>
        handleTPAMessage(callHandler, event as SdkEvent),
      false,
    );
  };

  return {
    initializeListenerHandlers,
  };
};
